import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import ReCAPTCHA from 'react-google-recaptcha';
import * as S from './Voucher.styles';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { GetVoucher } from '@app/api/voucher.api';
import { useForm } from 'antd/lib/form/Form';
import { Loading } from '../common/Loading/Loading';
import { BaseModal } from '../common/BaseModal/BaseModal';
import { setVoucher } from '@app/store/slices/voucherSlice';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { useLanguage } from '@app/hooks/useLanguage';
interface Voucher {
  code: string;
  verification: string;
  captcha: string;
}

export const initValues: Voucher = {
  code: '',
  verification: '',
  captcha: '',
};

export const VoucherForm: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const siteKey = process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY as string;
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const [form] = useForm();
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const dispatch = useAppDispatch();
  const handleSubmit = async (values: Voucher) => {
    setLoading(true);
    GetVoucher(values)
      .then((res) => {
        sessionStorage.setItem('token', res.Key);
        dispatch(setVoucher(res));
        if (res.Active) {
          error();
          setLoading(false);
        } else {
          navigate('../principle');
          setLoading(false);
        }
      })
      .catch(() => {
        handleChange(null);
        setLoading(false);
      });
  };
  const error = () => {
    BaseModal.error({
      title: t('Vinmec thông báo'),
      content: t('Voucher đã được kích hoạt'),
      okText: t('Xem thông tin các thành viên'),
      onOk: () => {
        navigate(`../persons`);
      },
    });
  };
  const handleChange = (values: string | null) => {
    form.setFieldsValue({
      ['captcha']: values,
    });
    setIsCaptchaVerified(!!values);
  };
  if (isLoading) return <Loading />;
  return (
    <div className="OutSide">
      <Auth.FormWrapper>
        <BaseForm
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
          initialValues={initValues}
          onFinishFailed={() => console.log(1)}
        >
          <Auth.FormTitle className="title">
            {t('Chào mừng quý khách đến với cổng đăng ký thành viên của ')}
            <br /> {t('chương trình Chăm sóc sức khỏe VINMEC')}
          </Auth.FormTitle>
          <Auth.FormTitle className="note">
            <i>{t('Vui lòng làm theo hướng dẫn sau để kích hoạt và đăng ký thành viên sử dụng')}</i>
          </Auth.FormTitle>

          <S.LoginDescription></S.LoginDescription>
          <Auth.FormItem
            label={t('Số thứ tự voucher')}
            name="code"
            className="hide-error"
            rules={[{ required: true, message: '', pattern: /^[a-zA-Z0-9]+$/ }]}
          >
            <Auth.FormInput placeholder={t('Nhập số thứ tự voucher')} />
          </Auth.FormItem>
          <Auth.FormItem
            className="hide-error"
            label={t('Mã kích hoạt voucher')}
            name="verification"
            rules={[{ required: true, message: t('') }]}
          >
            <Auth.FormInput placeholder={t('Nhập mã kích hoạt voucher')} />
          </Auth.FormItem>
          <Auth.FormItem
            name="captcha"
            rules={[{ required: true, message: '' }]}
            style={{ justifyContent: 'center', display: 'flex', height: '74px', width: '100%' }}
          >
            <ReCAPTCHA
              hl={language}
              sitekey={siteKey}
              onChange={(val) => handleChange(val)}
              ref={recaptchaRef}
              onExpired={() => handleChange(null)}
              onErrored={() => {
                () => handleChange(null);
              }}
            />
          </Auth.FormItem>
          <Auth.SubmitButton type="primary" htmlType="submit" loading={isLoading} disabled={!isCaptchaVerified}>
            {t('Tiếp tục')}
          </Auth.SubmitButton>
        </BaseForm>
      </Auth.FormWrapper>
    </div>
  );
};
